export const unicodeToUnified = (code) => Array.from(code)
    .map((s) => { var _a; return (_a = s.codePointAt(0)) === null || _a === void 0 ? void 0 : _a.toString(16); })
    .join("-");
export const unicodeFromUnified = (unified) => String.fromCodePoint(...unified.split("-").map((u) => parseInt(u, 16)));
//# sourceMappingURL=unicode.js.map